<template>
    <component :is="layout || 'section'">
      <router-view/>
  </component>
</template>
<script setup>
    // Vue imports
    import { ref, computed } from 'vue'
    import { useRouter } from 'vue-router'
    import { useStore } from "vuex"

    // Hooks
    const router = useRouter()
    const store = useStore()

    // Injects

    // Computeds
    const layout = computed(() => {
        return router.currentRoute.value.meta.layout
    })

    // Variables

    // Methods
    
</script>

<style lang="scss">
  #app {
      font-family: 'Playfair Display';
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      text-align: left;
      color: #2c3e50;
  }
  
  // Variable overrides  // Originals
  $primary: #0D6EFD;      // #0D6EFD;
  $secondary: #6C757D;    // #6C757D;
  $success: #75A8A5;      // #198754;
  $info: #0DCAF0;         // #0DCAF0;
  $warning: #FFC107;      // #FFC107;
  $danger: #f40044;       // #DC3545;
  $light: #dedede;        // #F8F9FA;
  $dark: #212529;         // #212529;
  

  // Then import Bootstrap
  @import "../node_modules/bootstrap/scss/bootstrap";

</style>
